export const formatDate = date => `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
